export default __webpack_public_path__ + "static/media/survey-on-dashboard.da820182.png";